<template>
  <div
    class="content has-text-left"
    :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
  >

    <table
      id="cpa-commissions"
      class="table is-striped is-responsive"
      :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
    >
      <thead>
        <tr>
          <th>{{$t('datetime').tUpper()}}</th>
          <th>{{$t('client').tUpper()}}</th>
          <th>{{$t('commission_amount').tUpper()}}</th>
          <th>{{$t('tier_name').tUpper()}}</th>
          <th>{{$t('trades_completed').tUpper()}}</th>
          <th>{{$t('volume_traded').tUpper()}}</th>
          <th>{{$t('status').tUpper()}}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(cpac, i) in CPACommissions"
          :key="i"
        >
          <td>{{ $formatDateTime(cpac.created_at) }}</td>
          <td>{{ $constructFullClientName(cpac.firstname, cpac.lastname, cpac.company_name) }}</td>
          <td>{{ $formatMoney(cpac.commission_amount, '$') }}</td>
          <td>{{ cpac.tier_name }}</td>
          <td>{{ cpac.trades_completed }} / {{ cpac.trades_required }}</td>
          <td>{{ cpac.volume_traded }} / {{ cpac.volume_required }}</td>
          <td>{{ cpac.status }}</td>

        </tr>
      </tbody>
    </table>

    <pagination
      ref="cpaCommissions"
      for="cpa-commissions"
      :records="pagination.totalRows"
      :per-page="pagination.rowsPerPage"
      :chunk="4"
      :count-text="pagination.totalRows + ' ' + $t('records') "
    ></pagination>
  </div>
</template>

<script>
import { Pagination, PaginationEvent } from 'vue-pagination-2-bulma'
import { mapActions, mapGetters } from 'vuex'
import { service } from '../../app'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      CPACommissions: {},
      pagination: {
        currentPage: 1,
        totalRows: 0,
        rowsPerPage: 10,
      },
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      config: 'config/config',
      Language: 'language/code',
    }),
  },
  mounted() {
    PaginationEvent.$on('vue-pagination::cpa-commissions', page => {
      this.pagination.currentPage = page
      this.getIBCPACommissions()
    })

    this.getIBCPACommissions()
  },
  methods: {
    getIBCPACommissions() {
      this['logoLoader/set'](true)
      service
        .post('/ib/get-cpa-commissions', {
          ibID: this.User.info.ID,
          page: this.pagination.currentPage,
          rowsPerPage: this.pagination.rowsPerPage,
        })
        .then(response => {
          if (response.data) {
            this.CPACommissions = Object.assign({}, response.data.list)
            this.pagination.totalRows = response.data.count
            this['logoLoader/set'](false)
          }
        })
        .catch(error => {
          if (typeof error.response.data !== 'undefined') {
            this.$toasted.error(error.response.data.detail, { duration: 4000 })
            this['logoLoader/set'](false)
          }
        })
    },
    ...mapActions([
      'logoLoader/set',
      // 'user/setIB',
    ]),
  },
}
</script>



// WEBPACK FOOTER //
// CPACommissions.vue?26331dca